export const REPROCESSING_INVOICE_PROCESS_STATUS = [
  'pending',
  'processing',
  'completed',
  'failed',
  'cancelled',
] as const;
